<template>
  <div>
    <div class="local__mapa">
      <InternaLocalizacaoMapa :location="actualEmpreendimento"></InternaLocalizacaoMapa>
    </div>
  </div>
</template>
<script>
import InternaLocalizacaoMapa from './InternaLocalizacaoMapa'
import { mapGetters } from 'vuex'
export default {
  components: {
    InternaLocalizacaoMapa
  },
  computed: {
    ...mapGetters([
      'empreendimentoApartamentos',
      'actualEmpreendimento'
    ])
  },
  created () {
    this.$store.dispatch('showEmpreendimentoApartamentos', this.$route.params.slug)
    this.$store.dispatch('showEmpreendimento', this.$route.params.slug)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaLocalizacao.vue